module.exports = __webpack_public_path__ + "img/logo_golf_w.102af95c.png";